import React from 'react'
import './header.scss'
import logo from './klicksieger-logo.jpg'
import Menu from './menu'

function Header() {
  const [isScrolled, setScrolled] = React.useState(false)

  const handleScroll = React.useCallback(() => {
    window.scrollY > 0 ? setScrolled(true) : setScrolled(false)
  }, [setScrolled])

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll)
  })

  return (
    <header className={isScrolled ? 'scrolled' : ''}>
      <div className="container">
        <div className="logo">
          <img src={logo} alt="klick:sieger Website Monitoring" />
        </div>
        <Menu />
      </div>
    </header>
  )
}

export default Header
